import { createSlice } from "@reduxjs/toolkit";

const retailerFilterSlice = createSlice({
  name: "retailerFilter",
  initialState: {
    status: null,
    search:null,
  },
  reducers: {
    setStatusFilter: (state, action) => {
      state.status = action.payload ?? null;
    },

    setSearchFilter: (state, action) => {
      state.search = action.payload ?? null;
    },

    clearSearchFilter: (state) => {
      state.search = null;
    },
  },
});

export const {  setStatusFilter, setSearchFilter, clearSearchFilter} = retailerFilterSlice.actions;

export const selectRetailerState = (state) =>
  state.retailerFilter;

export default retailerFilterSlice.reducer;
